<template>
    <FullFillBox
        :pageID="1034"
        @permissionData="(data) => {
            this.permissionDetails = data
            if(data.add === 1){
                this.showAddButton = true
            }
            if(data.edit === 1){
                this.showEditButton = true
            }
            if(data.delete === 1){
                this.showDeleteButton = true
            }
        }"
    >
        <h5>{{ $t('main_cat_table') }}</h5>
        <hr>
        <div class="row">
            <div class="col-3 d-flex flex-column justify-content-center">Group By</div>
            <div class="col-9">
                <select class="form-select" @change="groupBy" v-model="groupByID">
                    <option class="form-select" value="0">No</option>
                    <option value="1">Category</option>
                    <option value="2">BrandName</option>
                    <option value="3">Size</option>
                </select>
            </div>
        </div>
        <hr>
        <div ref="myTable" id="my-element" style="width: 100%;"></div>

    </FullFillBox>

    <!--   PopupMenu Open Printer Setting List  -->
    <vue-final-modal v-model="popUpShow" classes="modal-container" content-class="modal-content"
                     style="margin-top: 20vh;margin-right: 5%;margin-left: 5%;height: 10px">
        <button class="modal__close" @click="closeEditPopUp">
            <i class="bi bi-x-lg"></i>
        </button>
        <span class="modal__title"></span>
        <div class="modal__content" style="background-color: white;border: black solid 3px;height: auto;width: auto">
            <h3>Edit</h3>
            <div class="row">
                <div class="col-3">Size Details</div>
                <div class="col-9"><input type="text" v-model="thisItemData.size_detail"></div>
            </div>
            <button @click="updateSizeDetail">Update</button>
            <hr>
        </div>
    </vue-final-modal>
</template>
<script>
import FullFillBox from "@/components/routerViewLocation/FullFillBox.vue";
import {TabulatorFull as Tabulator} from "tabulator-tables";
import OtherDetailsEditPopUp from "@/components/OtherDetailsEditPopUp.vue";

export default {
    components: {OtherDetailsEditPopUp, FullFillBox},
    data() {
        return {
            permissionDetails: {},
            showDeleteButton: false,
            showEditButton: false,
            showAddButton: false,
            tableData: [],
            column: [],
            groupFlag: false,

            popUpShow: false,
            thisItemData: {},

            groupByID: "0",
        }
    },
    methods: {
        groupBy(){
            switch (this.groupByID) {
                case "0":
                    this.tabulator.setGroupBy()
                    break
                case "1":
                    this.tabulator.setGroupBy(['category'])
                    break
                case "2":
                    this.tabulator.setGroupBy(['brandName'])
                    break
                case "3":
                    this.tabulator.setGroupBy(['size_group'])
                    break
            }
            this.tabulator.redraw(true)
        },
        async updateSizeDetail() {
            // await this.$mainApi.post('api/other-details/mainCat/', {
            //     id: this.thisItemData.sizeDetailID,
            //     size_detail: this.thisItemData.size_detail,
            // }).then(response => {
            //     if(response.data.status === 80){
            //         this.$toast.success(this.$t('common_update_success'))
            //         this.closeEditPopUp()
            //         this.getUpdateData()
            //     }else{
            //         this.$toast.error(this.$t('common_update_failed'))
            //     }
            // })
        },
        async getUpdateData() {
            await this.$mainApi.get('api/other-details/mainCat/')
                .then(response => {
                    if (response.data.status === 80) {
                        this.tableData = response.data.details.returnData
                        this.tabulator.setData(this.tableData)
                    }
                })
        },
        closeEditPopUp() {
            this.$store.commit('setIsBlackLayout', false)
            this.popUpShow = false
        },
        groupToggler() {
            this.groupFlag = !this.groupFlag
            if (this.groupFlag) {
                this.tabulator.setGroupBy(['size_group'])
            } else {
                this.tabulator.setGroupBy()
            }
        },
        async getBackendData() {
            await this.$mainApi.get('api/other-details/mainCat/')
                .then(response => {
                    if (response.data.status === 80) {
                        let new_column = [
                            {key: 'catID', show: false, format: 'string'},
                            {key: 'category', show: true, format: 'string'},
                            {key: 'brandID', show: false, format: 'string'},
                            {key: 'brandName', show: true, format: 'string'},
                            {key: 'sizeID', show: false, format: 'string'},
                            {key: 'size_group', show: true, format: 'string'},
                        ]
                        this.tableData = response.data.details
                        for (let i = 0; i < new_column.length; i++) {
                            let data = new_column[i]
                            this.column.push({
                                title: data.key, field: data.key, sorter: "string", resizable: false,
                                responsive: 0, visible: data.show,
                                headerFilter: "list",
                                headerFilterParams: {
                                    valuesLookup: true,
                                    sort: 'asc',
                                    clearable: true,
                                    autocomplete: true,
                                    listOnEmpty: true
                                }
                            })
                        }
                        // this.column.push({
                        //     formatter: () => {
                        //         return "<i class='bi bi-pencil-fill'></i>"
                        //     },
                        //     headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", resizable: false,
                        //     headerMenu: this.getHeaderMenu,
                        //     headerSort: false, width: 10, responsive: 0,
                        //     cellClick: (e, row, formatterParams) => {
                        //         if(this.showEditButton){
                        //             this.thisItemData = row.getData()
                        //             this.popUpShow = true
                        //             this.$store.commit('setIsBlackLayout', true)
                        //         }else{
                        //             this.$toast.error(this.$t('error_no_permission'))
                        //         }
                        //     }
                        // })
                        // console.log(this.column)
                        this.tabulator = new Tabulator(this.$refs.myTable, {
                            placeholder: "<h3>" + this.$t('common_no_data') + "</h3>",
                            data: this.tableData,
                            columns: this.column,
                            reactiveData: true, //enable data reactivity
                            maxHeight: '90vh',
                            responsiveLayout: 'collapse',
                            layout: "fitColumns",
                            movableColumns: true,
                            movableRows: false,
                            groupStartOpen: false,
                            initialSort: [
                                {column: "id", dir: "asc"},
                            ],
                        })
                    }
                })
        }
    },
    async mounted() {
        this.$store.commit('setIsTopLoading', true)
        await this.getBackendData()


        this.$store.commit('setIsTopLoading', false)
    }
}
</script>